<template>
  <div class="list-layout">
    <transition-group v-if="data"
                      tag="ul"
                      class="list-wrapper"
                      :name="transition"
                      :class="{'is-wrap': wrap}">
      <li v-for="(item, index) in data"
          :key="typeof item === 'object' ? item[dataKey] || 'item-' + index : 'item-' + index">
        <slot :item="item" :item-index="index"></slot>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'ListLayout',
  props: {
    transition: String,
    wrap: Boolean,
    data: {
      type: Array
    },
    dataKey: {
      type: String,
      default: 'id'
    }
  }
}
</script>

<style lang="scss">
  .list-layout {
    position: relative;
    height: 100%;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      &.list-wrapper {
        &.is-wrap {
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
</style>
